<template>
      <div class="staffRequirementCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'staffRequirement', params: {} }">
          Staff Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'staffRequirementCreate', params: {} }">
            Create Staff Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Staff Requirement</v-card-title>
          <v-card-text>
            <staffRequirement-form></staffRequirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import StaffRequirementForm from './StaffRequirementForm.vue';

    export default {
      name: 'staffRequirement',
      components: {
        StaffRequirementForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    